<template>
  <div class="main-custom">
    <Header />
    <div id="printable-consult-search" class="container">
      <b-loading isFullPage :active="isLoading" />
      <h1 class="title spacing-mt-20 has-text-color-7">
        {{ Home.CONSULT_PROCESS }}
      </h1>
      <h2 class="subtitle has-text-color-7">
        {{ General.FIND_YOUR_PROCESS }}
      </h2>

      <MediaShareBar
        :url="currentUrl"
        :title="Home.CONSULT_PROCESS"
        :description="General.FIND_YOUR_PROCESS"
        printId="printable-consult-search"
      />

      <section :class="{ 'spacing-mx-30': !isMobile }">
        <CustomAdvancedSearch
          :class="{ 'spacing-mx-10': !isMobile }"
          isExternalSearch
        />
        <SearchView
          :processes="getSearchedProcessList"
          :currentPage="currentPage"
          :setCurrentPage="setCurrentPage"
          :setOrderBy="setOrderBy"
          :perPage="perPage"
          :setPerPage="setPerPage"
          isExternal
        />
      </section>
    </div>
    <Footer :isReduced="true" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import Header from "@/layout/Header";
import Footer from "@/layout/Footer.vue";
import SearchView from "@/layout/SearchView";

import CustomAdvancedSearch from "@/components/CustomAdvancedSearch";
import MediaShareBar from "@/components/MediaShareBar";
import { General, Home } from "@/utils/constants";
import { getFormattedFilterList } from "@/utils/filterTagsUtility";
import { processfilterData } from "@/utils/filters";
import { debounce } from "lodash";

export default {
  name: "ConsultSearch",
  components: {
    Header,
    Footer,
    SearchView,
    CustomAdvancedSearch,
    MediaShareBar
  },

  props: {
    nup: {
      type: String,
      default: ""
    },

    showSingle: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      General,
      Home,
      currentPage: 1,
      perPage: 5,
      orderBy: { key: "date", name: "Data", order: "desc" },
      search: "",
      currentFilterList: [],
      filterList: {},
      isLoading: false,
      selectedProcess: {}
    };
  },

  computed: {
    ...mapGetters({
      getSearchedProcessList: "getSearchedProcessList",
      getTimeLineItens: "getTimeLineItens",
      getProcessTime: "getProcessTime",
      getExternalAbbreviation: "getExternalAbbreviation",
      getFilterList: "getFilterList",
      getIsSearchSuite: "getIsSearchSuite",
      isMobile: "isMobile"
    }),

    currentUrl() {
      return window.location.href;
    }
  },

  watch: {
    getSearchedProcessList: {
      handler(value) {
        if (value.list.length === 1 && !this.showSingle)
          this.$router.push({
            name: "processConsultDetail",
            params: {
              nup: value.list[0].nup
            }
          });
      }
    },
    getFilterList({ search, currentFilterList }) {
      this.search = search;
      this.currentFilterList = currentFilterList;
      this.filterList = getFormattedFilterList(this.currentFilterList);
      this.setCurrentPage(1);
    }
  },

  async beforeMount() {
    const { search, currentFilterList } = this.getFilterList;
    this.search = search;
    this.currentFilterList = currentFilterList;
    this.filterList = getFormattedFilterList(this.currentFilterList);

    if (this.nup) this.setFilterList({ nup: this.nup });

    this.processesSearch();
  },

  methods: {
    ...mapActions({
      searchProcessByFilter: "searchProcessByFilter",
      searchViprocProcess: "searchViprocProcess"
    }),
    ...mapMutations({
      setFilterList: "setFilterList"
    }),
    setCurrentPage(page) {
      this.currentPage = page;
      this.processesSearch();
    },
    setPerPage(perPage) {
      this.perPage = perPage;
      this.processesSearch();
    },
    setOrderBy(order) {
      this.orderBy = order;
      this.processesSearch();
    },

    processesSearch: debounce(async function() {
      this.isLoading = true;
      if (this.getIsSearchSuite) {
        await this.searchProcessByFilter({
          filters: {
            nup: this.nup || undefined,
            search: this.search || undefined,
            ...processfilterData(this.filterList)
          },
          page: this.currentPage,
          order_by: { [this.orderBy.key]: this.orderBy.order },
          paginator_count: this.perPage
        });
      } else this.searchViprocProcess(this.search);
      this.isLoading = false;
    }, 200)
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
.container {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 90%;
  padding: 15px 0;
  min-height: 400px;
}
.header-label {
  background-color: var(--app-background-color);
  align-items: center;
  border-radius: 5px !important;
}
.icon {
  margin-right: 0.75rem;
}

@media print {
  .no-print {
    display: none;
  }

  @page {
    margin: 0;
  }
}

.title,
.subtitle {
  margin-left: 30px;

  @media screen and (max-width: $tablet) {
    margin-left: 15px;
  }
}
</style>
